/**
 * API Error Handler Utility
 * Provides consistent error handling across instructor portal components
 */

export function handleApiError(error, router, defaultMessage = 'An error occurred') {
  if (error.response) {
    const status = error.response.status;

    if (status === 401) {
      // Authentication required
      const currentPath = router.currentRoute.fullPath;
      router.push(`/login?redirect=${encodeURIComponent(currentPath)}`);
      return 'Authentication required';
    } else if (status === 403) {
      return 'You do not have permission to access this resource';
    } else if (status === 404) {
      // Prefer the backend's message (e.g. 'Student not found in your courses');
      // data may be an HTML error page or DRF's {detail: ...}, so fall back.
      return (error.response.data && error.response.data.error) || 'Resource not found';
    } else if (status === 400) {
      // Validation error
      return error.response.data.error || defaultMessage;
    } else if (status >= 500) {
      return 'Server error. Please try again later.';
    }
  } else if (error.request) {
    // Network error
    return 'Network error. Please check your connection.';
  }

  return defaultMessage;
}
